import { createFileRoute } from '@tanstack/react-router'

// Раздел «Пулы» — грид на index и полноэкранный дриллдаун на $poolId;
// сам layout только держит крошку «Пулы» для детали.
export const Route = createFileRoute('/telephony/pools')({
  staticData: { crumb: 'Пулы' },
})
